'use client';

import React from 'react';
import Image from 'next/image';
import './BusinessGrow.css';
import box1 from '@/public/assets/images/BusinessGrowbox1.png';
import box2 from '@/public/assets/images/BusinessGrowbox2.png';
import box3 from '@/public/assets/images/BusinessGrowbox3.png';

const BusinessGrow = () => {
  const cards = [
    {
      id: 1,
      title: 'Increased Sales',
      description: 'Stand out from the competition with AR-Pictures',
      image: box1,
      ribbonClass: 'ribbon-right'
    },
    {
      id: 2,
      title: 'Higher Product Value',
      description: 'Our innovative technology and trending concepts add value to your products.',
      image: box2,
      ribbonClass: ''
    },
    {
      id: 3,
      title: 'Increased Profits',
      description: 'Use AR-Photo to build business boosting hype and virality',
      image: box3,
      ribbonClass: 'ribbon-left'
    }
  ];

  return (
    <section className="business-grow-section" id="business-grow">
      <div className="white-band"></div>
      <div className="business-grow-container">
        <div className="business-grow-header">
          <h2 className="business-grow-title">This platform helps your business grow</h2>
          <p className="business-grow-subtitle">
            By joining Padami, your business is enhanced and elevated to the next stage of growth.
          </p>
        </div>

        <div className="business-cards-grid">
          {cards.map((card) => (
            <div key={card.id} className={`business-card ${card.ribbonClass}`}>
              <div className="card-icon">
                <Image src={card.image} alt={card.title} width={80} height={80} objectFit="contain" />
              </div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessGrow;
